import { useTranslation } from 'react-i18next';
import { type EntityOrSuggestionRef, type ProcessStepRecording } from '@bliks-io/contracts';
import { InfoHint, STEP_FIELD_ICONS } from '@bliks-io/ui';
import { HelpersPicker } from '@/components/entity-pickers/helpers/HelpersPicker';

interface HelpersSectionProps {
  recording: ProcessStepRecording | null;
  onChange: (field: string, value: unknown) => void | Promise<void>;
}

const EMPTY_REFS: EntityOrSuggestionRef[] = [];

export function HelpersSection({ recording, onChange }: HelpersSectionProps) {
  const { t } = useTranslation();

  return (
    <div className="bg-bg-1 border border-border-14 rounded-lg p-2">
      <div className="flex items-center gap-1.5 mb-3">
        <STEP_FIELD_ICONS.helpers className="h-3.5 w-3.5 text-fg-secondary" />
        <span className="text-sm font-semibold text-foreground">
          {t('viralRecording.sections.helpers')}
        </span>
        <InfoHint content={t('viralRecording.tooltips.helpers')} />
      </div>
      <HelpersPicker
        persons={recording?.helpers?.persons ?? []}
        orgFunctions={recording?.helpers?.orgFunctions ?? EMPTY_REFS}
        systems={recording?.helpers?.systems ?? EMPTY_REFS}
        documents={recording?.helpers?.documents ?? []}
        onHelpersChange={(next) => {
          // Two staged paths, one confirm: `onChange` writes per dot-path, so
          // both slots of the payload land in the same staging map.
          void onChange('helpers.persons', next.persons);
          void onChange('helpers.orgFunctions', next.orgFunctions);
        }}
        onSystemsChange={(next) => void onChange('helpers.systems', next)}
        onDocumentsChange={(next) => void onChange('helpers.documents', next)}
        processId={recording?.process}
        recordingId={recording?._id}
        entitySuggestions={recording?.entitySuggestions}
      />
    </div>
  );
}
